import React, { useContext, useEffect, useState } from 'react'
import InputRegister from "../../blocks/ui/InputDesign";
import placeholder from '../../../assets/Image Placeholder.jpg'
import { FaUsers } from "react-icons/fa6";
import { confirmPasswordValidator, contactValidator, emailValidator, firstNameValidator, fullNameValidator, lastNameValidator, passwordValidator } from '../../../utils/validator';
import { DContext } from '../../../context/Datacontext';
import { fetchManager } from '../../services/fetchManager';
import { fetchTeamLead } from '../../services/fetchTeamLead';
import { compressImage } from '../../../utils/compressImages';
import FloatingLoading from '../../blocks/Layout/Loading';

export default function AccountCreate({ errors, setErrors, users, setUsers, profileFile, setProfileFile, currentUser, reportingMates, setReportingMates }) {

    const { BeURL, showAlert } = useContext(DContext)

    // Reporting Mates
    const [managerIds, setManagerIds] = useState(null)
    const [teamleadIds, setTeamleadIds] = useState(null);

    useEffect(() => {
        const fetchManagers = async () => {
            if (currentUser.role === 'admin' && (users.role === 'teamlead' || users.role === 'recruiter')
            ) {
                await fetchManager(
                    currentUser.company.companyId, BeURL, showAlert, setManagerIds
                );
            }
        };

        fetchManagers();
    }, [currentUser.company.companyId, users.role]);

    // Fetch Team Lead
    useEffect(() => {
        console.log("It is call1")

        const fetchLeads = async () => {
            console.log("It is called111")

            if (users.role === 'recruiter' &&
                (currentUser.role === 'admin')) {

                await fetchTeamLead(currentUser.company.companyId, BeURL, showAlert,
                    reportingMates.reportingManagerId, setTeamleadIds
                );
            }

            if (users.role === 'recruiter' &&
                (currentUser.role === 'manager')) {
                await fetchTeamLead(currentUser.company.companyId, BeURL, showAlert,
                    currentUser.id, setTeamleadIds
                );
            }
        };

        if (users.role === "recruiter" || reportingMates?.reportingManagerId)
            fetchLeads();
    }, [currentUser.company.companyId, reportingMates?.reportingManagerId, users.role]);

    // Profile File Handle

    const [previewProfile, setPreviewProfile] = useState(placeholder);

    if (!currentUser) return <FloatingLoading />

    const roleOptions = currentUser.role === "admin" ? ["manager", "teamlead", "recruiter"]
        : currentUser.role === "manager" ? ["teamlead", "recruiter"]
            : (currentUser.role === "superadmin") ? ["helpdesk", "admin"] :
                currentUser.role === "helpdesk" ? ["admin", "manager", "teamlead", "recruiter"] : [];


    // Handle the inputs
    const handleusers = (name, value) => {
        // Update state with allowed patterns
        if (["firstName", "lastName", "fullName"].includes(name)) {
            if (/^[A-Za-z. ]*$/.test(value)) {
                setUsers((prev) => ({ ...prev, [name]: value }));
            }
        } else if (["contact", "alternateContact"].includes(name)) {
            if (/^[0-9]*$/.test(value)) {
                setUsers((prev) => ({ ...prev, [name]: value }));
            }
        } else {
            setUsers((prev) => ({ ...prev, [name]: value }));
        }

        // Validation
        let errorMsg = '';
        switch (name) {
            case "firstName":
                errorMsg = firstNameValidator(value);
                break;

            case "fullName":
                errorMsg = fullNameValidator(value);
                break;

            case "lastName":
                if (value.trim()) errorMsg = lastNameValidator(value); // optional
                break;

            case "email":
                errorMsg = emailValidator(value);
                break;

            case "alternateEmail":
                if (value.trim()) errorMsg = emailValidator(value); // optional
                break;

            case "contact":
                errorMsg = contactValidator(value);
                break;

            case "alternateContact":
                if (value.trim()) errorMsg = contactValidator(value); // optional
                break;

            case "password":
                errorMsg = passwordValidator(value);
                break;

            case "confirmPwd":
                errorMsg = confirmPasswordValidator(value, users.password);
                break;

            default:
                break;
        }
        // Update error state
        setErrors((prev) => ({
            ...prev,
            users: {
                ...prev.users,
                [name]: errorMsg,
            },
        }));

    };


    const fileToDataUrl = (f) =>
        new Promise((resolve, reject) => {
            try {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (e) => reject(e);
                reader.readAsDataURL(f);
            } catch (e) {
                reject(e);
            }
        });
    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        let compressed = await compressImage(file)
        if (!compressed) compressed = file;

        setProfileFile(compressed);
        const dataUrl = await fileToDataUrl(compressed);
        setPreviewProfile(dataUrl);

    };

    // Reporting Managers :

    const handleLeads = (name, values) => {
        setReportingMates((prev) => ({ ...prev, [name]: values }))
    }

    return (
        <section className="px-4 sm:px-6 md:px-12 lg:px-16 xl:px-24 " >
            {/* Heading */}
            <div className=" flex flex-col items-center">
                <div className="bg-white px-5 rounded-xl pt-2 w-[1200px] ">
                    {/* Fixed Header */}
                    <div className="sticky top-0 bg-white z-10 flex justify-start items-center py-2 border-b mb-4">
                        <FaUsers className='text-2xl text-primary-500 mx-2' /><h3 className="text-lg font-semibold">Users Details</h3>

                    </div>
                    <div className="max-h-[600px] overflow-y-auto pr-2">
                        {/* ---------- User Account ---------- */}

                        <div className="w-full mb-2 border  border-primary-50 px-3 shadow-sm rounded-xl " >

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">

                                <label className="inline">
                                    <img
                                        src={previewProfile}
                                        alt="Company Logo"
                                        className="w-24 h-24 object-cover rounded-full border inline"
                                    />
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleProfileChange}
                                        className="hidden "
                                    />
                                    <span className='text-sm px-2 text-primary-300 font-medium'>Click the profile to upload</span>
                                </label>

                                {[
                                    {
                                        label: "First Name", name: "firstName", value: users.firstName, error: errors.users?.firstName, mandatory: true,
                                        required: true
                                    },
                                    { label: " Last Name", name: "lastName", value: users.lastName, error: errors.users?.lastName }
                                ].map((field, idx) => (
                                    <InputRegister
                                        key={idx}
                                        label={field.label}
                                        value={field.value}
                                        name={field.name}
                                        mandatory={field.mandatory}
                                        required={field.required}
                                        placeholder={field.label}
                                        type="text"
                                        className="min-w-full md:w-full"
                                        error={field.error}
                                        onChange={(e) =>
                                            handleusers(e.target.name, e.target.value)
                                        }
                                    />
                                ))}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">

                                {[
                                    {
                                        label: "Full Name", name: "fullName", value: users.fullName, error: errors.users?.fullName, mandatory: true,
                                        required: true
                                    },
                                    {
                                        label: " Email", name: "email", value: users.email, error: errors.users?.email, mandatory: true,
                                        required: true
                                    },
                                    { label: " Alternate Email", name: "alternateEmail", value: users.alternateEmail, error: errors.users?.alternateEmail },
                                ].map((field, idx) => (
                                    <InputRegister
                                        key={idx}
                                        label={field.label}
                                        value={field.value}
                                        name={field.name}
                                        mandatory={field.mandatory}
                                        required={field.required}
                                        placeholder={field.label}
                                        type="text"
                                        className="min-w-full md:w-full"
                                        error={field.error}
                                        onChange={(e) =>
                                            handleusers(e.target.name, e.target.value)
                                        }
                                    />
                                ))}
                            </div>

                            <div className={`grid grid-cols-1 ${currentUser.role === 'teamlead' ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-4 mt-2`}>

                                {[
                                    {
                                        label: "Contact Number",
                                        name: "contact",
                                        value: users.contact,
                                        error: errors.users?.contact,
                                        mandatory: true,
                                        required: true
                                    },
                                    {
                                        label: "Alternate Contact Number",
                                        name: "alternateContact",
                                        value: users.alternateContact,
                                        error: errors.users?.alternateContact
                                    },
                                    { label: "Employement Id ", name: "empId", value: users.empId, error: errors.users?.empId }

                                ].map((field, idx) => (
                                    <InputRegister
                                        key={idx}
                                        label={field.label}
                                        value={field.value}
                                        name={field.name}
                                        mandatory={field.mandatory}
                                        required={field.required}
                                        placeholder={field.label}
                                        type="text"
                                        className="min-w-full md:w-full"
                                        error={field.error}
                                        onChange={(e) =>
                                            handleusers(e.target.name, e.target.value)
                                        }
                                    />
                                ))}




                            </div>

                            <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 my-2`}>

                                {[
                                    {
                                        label: "Password", name: "password", value: users.password, error: errors.users?.password, mandatory: true, required: true
                                    },
                                    { label: "Confirm Password ", name: "confirmPwd", value: users.confirmPwd, error: errors.users?.confirmPwd, mandatory: true, required: true },

                                ].map((field, idx) => (
                                    <InputRegister
                                        key={idx} empId
                                        label={field.label}
                                        value={field.value}
                                        name={field.name}
                                        mandatory={field.mandatory}
                                        required={field.required}
                                        placeholder={field.label}
                                        type="password"
                                        className="min-w-full md:w-full"
                                        error={field.error}
                                        onChange={(e) =>
                                            handleusers(e.target.name, e.target.value)
                                        }
                                    />)
                                )}

                                <div className={`pt-1 ${currentUser.role === 'teamlead' ? 'hidden' : 'block'}`}>
                                    <label className="block text-sm font-medium text-gray-600 mb-1">
                                        Role<sup className="text-red-500 text-sm">*</sup>
                                    </label>
                                    <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                        onChange={(e) =>
                                            handleusers(e.target.name, e.target.value)
                                        }
                                        name='role'
                                        value={users.role}>
                                        <option className='text-gray-500' >Select Role</option>
                                        {
                                            roleOptions.map((r, i) =>
                                            (

                                                <option value={r} key={i}>{r}</option>

                                            ))
                                        }
                                    </select>
                                    {errors.users?.role && < p class="text-sm text-red-500 mt-1 hidden">Role is Required</p>}
                                </div>

                            </div>

                            {/* Reporting Team Lead */}
                            <div className={`grid grid-cols-1 ${currentUser.role === 'admin' && 'md:grid-cols-3 '} gap-4 my-2`}>

                                {
                                    (currentUser.role === 'admin') && (users.role === 'teamlead' || users.role === 'recruiter') &&
                                    <div className='pt-1'>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            Reporting Manager<sup className="text-red-500 text-sm">*</sup>
                                        </label>
                                        <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                            onChange={(e) =>
                                                handleLeads(e.target.name, e.target.value)
                                            }
                                            name='reportingManagerId'
                                            value={reportingMates.reportingManagerId}>
                                            <option className='text-gray-500' >Select Manager</option>

                                            {
                                                managerIds && managerIds.length > 0 && managerIds.map((manager, i) =>
                                                (
                                                    <option value={manager.id} key={i}>{manager.fullName}</option>
                                                ))
                                            }
                                        </select>
                                        {!reportingMates.reportingManagerId && < p class="text-sm text-red-500 mt-1 hidden">Reporing Manager is Required</p>}
                                    </div>

                                }

                                {(currentUser.role === 'admin' || currentUser.role === 'manager') && (users.role === 'recruiter') &&

                                    <div className=''>
                                        <label className="block text-sm font-medium text-gray-600 mb-1">
                                            Reporting Team Lead<sup className="text-red-500 text-sm">*</sup>
                                        </label>
                                        <select className=" text-sm w-full border border-gray-300 rounded-lg px-3 py-[11px] bg-white text-gray-600
           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 "
                                            onChange={(e) =>
                                                handleLeads(e.target.name, e.target.value)
                                            }
                                            name='reportingTeamLeadIds'
                                            value={reportingMates.reportingTeamLeadIds}>
                                            <option className='text-gray-500' >Select Team Lead</option>
                                           
                                            {

                                                teamleadIds && teamleadIds.length > 0 && teamleadIds.map((teamlead, i) =>
                                                (
                                                    <option value={teamlead.id} key={i}>{teamlead.fullName}</option>
                                                ))
                                            }
                                        </select>
                                        {!reportingMates.reportingTeamLeadIds && < p class="text-sm text-red-500 mt-1 hidden">Reporing Team Lead is Required</p>}
                                    </div>

                                }
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </section >

    )
}
